import { render, staticRenderFns } from "./homeMenu.vue?vue&type=template&id=4778ac32&scoped=true&"
import script from "./homeMenu.vue?vue&type=script&lang=js&"
export * from "./homeMenu.vue?vue&type=script&lang=js&"
import style0 from "./homeMenu.vue?vue&type=style&index=0&id=4778ac32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4778ac32",
  null
  
)

export default component.exports